import React, { useMemo } from 'react';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Chat } from './Chat';
import { ChatMessage } from './ChatTypes';

const useContentWithoutData = (text: string) => {
    return useMemo(() => {
        if (!text.includes('<data>')) return text;
        if (!text.includes('</data>')) return text;
        const [_data, msg] = text.split('</data>');
        return msg;
    }, [text]);
};

const UserTextMessagePart = React.memo(({ text }: { text: string }) => {
    const textWithoutData = useContentWithoutData(text);
    return <Flexer padding=".5 0 0 0">
        {textWithoutData}
    </Flexer>;
});

export const UserMessage = React.memo(({ message }: { message: ChatMessage }) => {
    return <Chat.Message actor={<Chat.You />}>
        {message.content.map((p, i) => (
            <Flexer key={i}>
                {p.type === 'text' && <UserTextMessagePart text={p.text} />}
            </Flexer>
        ))}
    </Chat.Message>;
});
